


import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  inject
} from '@angular/core';

import {
  NavigationCancel,
  NavigationError,
  RouterOutlet,
  Router,
  NavigationStart,
  NavigationEnd
} from '@angular/router';
import { NavBarComponent } from "./shared/nav-bar/nav-bar.component";
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { LoaderService } from './services/loader-service/loader.service';
import { SnackBarService } from './services/snackbar-service/snack-bar.service';
import { AuthServiceService } from './services/auth-service/auth-service.service';

import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NavBarComponent,
    MatDialogModule,
    CommonModule,
  ],
  providers: [SnackBarService],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements AfterViewInit {
  percent = 0;
  isLoadingLoader = true;
  showNavbar: boolean = true;
  @ViewChild('progressBar') progressBar!: ElementRef;

  public router = inject(Router);
  public loaderService = inject(LoaderService);
  public cdr = inject(ChangeDetectorRef);

  constructor(public authService: AuthServiceService,
 
  ) {

    this.router.events.subscribe((event) => {
      this.showNavbar = !['/dashboard', '/consum-epcis', '/checkemail', '/extdashboard'].includes(this.router.url);
      if (event instanceof NavigationStart) {
        this.loaderService.show();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loaderService.hide();
      }
    });
  }

  private handleBeforeUnload(event: Event): void {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this.handleBeforeUnload.bind(this));
  }

  ngAfterViewInit() {
    this.loaderService.isLoading.subscribe((isLoading) => {
      this.isLoadingLoader = isLoading;
      if (isLoading) {
        this.percent = 0;
        this.simulateLoadingProcess();
      }
      this.cdr.detectChanges();
    });
  }

  simulateLoadingProcess() {
    const intervalTime = 100;
    const progressInterval = setInterval(() => {
      this.percent += 10;
      if (this.progressBar?.nativeElement) {
        this.progressBar.nativeElement.style.width = `${this.percent}%`;
      }
      if (this.percent >= 100 || !this.isLoadingLoader) {
        clearInterval(progressInterval);
        this.isLoadingLoader = false;
        this.cdr.detectChanges();
      }
    }, intervalTime);
  }
}